import { useConfigurationSelector } from "@nf/common";

export const useLocale = () => {
  const configuration = useConfigurationSelector();

  return configuration?.Locale;
};
